/* ================================================== */
/* CHECK IE
/* ================================================== */

function checkIe() {

	var ua   = window.navigator.userAgent,
		msie = ua.indexOf("MSIE ");

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		$('html').attr('data-browser', 'ie');
		return true;
	}

}

$(document).ready(checkIe());